import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function ProofTimeline() {
  const timeline = [{
    day: 'Día 30',
    desc: 'Los burós reciben tus cartas y deben investigar.'
  }, {
    day: 'Día 60',
    desc: 'Empezarás a recibir notificaciones de "Cuentas Eliminadas".'
  }, {
    day: 'Día 90',
    desc: 'Tu utilización de crédito estará optimizada y tu puntaje reflejará tu verdadera capacidad financiera, no tus errores del pasado.'
  }];
  return <section className="py-24 bg-white relative" data-id="element-112">
      <div className="container mx-auto px-6" data-id="element-113">
        <FadeIn data-id="element-114">
          <h2 className="text-3xl md:text-4xl font-bold text-center text-brand-dark mb-16" data-id="element-115">
            ¿Qué cambia en 90 días?
          </h2>
        </FadeIn>

        <div className="max-w-3xl mx-auto relative" data-id="element-116">
          {/* Vertical Line */}
          <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-1 bg-brand-pink/30 transform md:-translate-x-1/2 rounded-full" data-id="element-117" />

          <div className="space-y-12" data-id="element-118">
            {timeline.map((item, index) => <FadeIn key={index} delay={index * 0.2} direction={index % 2 === 0 ? 'right' : 'left'} data-id="element-119">
                <div className={`relative flex flex-col md:flex-row items-start md:items-center ${index % 2 === 0 ? 'md:flex-row-reverse' : ''}`} data-id="element-120">
                  {/* Timeline Dot */}
                  <div className="absolute left-4 md:left-1/2 w-6 h-6 bg-brand-gold rounded-full transform -translate-x-[10px] md:-translate-x-1/2 border-4 border-white shadow-md z-10 mt-1 md:mt-0" data-id="element-121" />

                  {/* Content Box */}
                  <div className={`ml-12 md:ml-0 w-full md:w-1/2 ${index % 2 === 0 ? 'md:pl-12' : 'md:pr-12 text-left md:text-right'}`} data-id="element-122">
                    <div className="bg-brand-cream p-6 rounded-xl border border-brand-gold/20 shadow-sm hover:shadow-md transition-shadow" data-id="element-123">
                      <span className="inline-block px-4 py-1 bg-brand-rose text-white text-sm font-bold rounded-full mb-3" data-id="element-124">
                        {item.day}
                      </span>
                      <p className="text-gray-700 font-medium leading-relaxed" data-id="element-125">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}